/**
 * Values from API orderAdDetail.statusFlags
 */
export enum OrderAdDetailStatus {
	ApprovalPending = "APPROVAL_PENDING",
	Cancelled = "CANCELLED",
	Confirmed = "CONFIRMED",
	Invoiced = "INVOICED",
	Produced = "PRODUCED",
	Rejected = "REJECTED",
	PastConfirmDeadline = "PAST_CONFIRM_DEADLINE",
	ConfirmDeadlineApproaching = "CONFIRM_DEADLINE_APPROACHING"
}
